import { Checkbox, Form, Select, Spin } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import FileInput from '../../../components/FileInput/FileInput';
import Input from '../../../components/Input/Input';
import { createClub } from '../../../service/clubs';
import { uploadClubImage } from '../../../service/files';
import { createClubGenres, getAllGenres } from '../../../service/genres';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';

import { useModal, UseModalStore } from '../../../store/useModal';
import { ModalType } from '../../../store/useModal/data';
import { useUserStore } from '../../../store/useUser';
import { navigateToClub } from '../../../utils/club';
import styles from './AddClub.module.scss';
import { FileFormItem } from '../../../components/FormItem/FormItem';
import ImageInput from '../../../components/ImageInput/ImageInput';
import useHeader from '../../../hooks/useHeader';

const { Option } = Select;

const AddClub = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const userId = useUserStore(state => state.id)

  const {data: genres, isFetching} = useQuery(
    ['genres'],
    () => getAllGenres(),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: 'Cadastro de clube', subheader: 'Membros' });

  const onFinish = async () => {
    if(loading) return;

    setLoading(true);

    const payload = form.getFieldsValue();

    payload.userId = userId

    const {error, success} = await createClub(payload, userId);

    if(error) {
      setLoading(false);
      return createErrorNotification(error);
    }

    if(payload.genres) await createClubGenres(success.id, payload.genres)

    delete payload.genres

    if(payload.file || payload.docRules){
      const {error: errorFile } = await uploadClubImage(success.id, payload)
      if(errorFile)
        createErrorNotification(errorFile)
    }

    setLoading(false);

    createSuccessNotification('Clube criado');
    createSuccessNotification('Para ter acesso ao gerenciamento desse clube faça o login novamente.');
  
    navigate(navigateToClub(success.name, success.id), { replace: true })
  }

  return(
    <div className={styles.container}>
      <div className={styles.maskContainer}></div>
        <div className={styles.createContainer}>
        <Spin spinning={loading}>
          <div className={styles.createForm}>
            <Form 
              layout="vertical" 
              form={form}
              onFinish={onFinish}
              id="formLogin" 
              className={styles.FormContainer}
            >
              <h2 className={styles.title}>Criar novo clube</h2>
              <FormItem
                label="Nome"
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Por favor, digite um nome.',
                  },
                  {
                    max: 50,
                    message: 'Nome deve ter entre 1 e 50 caracteres.',
                  }
                ]}
                required
              >
                <Input style={styles.input} />
              </FormItem>
              <FormItem
                label="Descrição"
                name="description"
                rules={[
                  {
                    required: true,
                    message: 'Por favor, digite uma descrição.',
                  }
                ]}>
                <Input style={styles.input} />
              </FormItem>
              <FormItem
                label="É Privado?"
                name="isPrivate"
                tooltip={{ title: "Selecione se desejar que o clube seja privado." }}>
                  <Checkbox className={styles.isPrivate} 
                            onChange={event => form.setFields([{name: 'isPrivate', value: event.target.checked}])}>          
                    Esse clube é privado.
                  </Checkbox>
              </FormItem>
              <FormItem
                label="Limite de membros"
                name="limitUsers"
                tooltip={{ title: "Número máximo de membros permitidos. Caso não queira, não preencha!" }}>
                <Input type='number' style={styles.input} />
              </FormItem>
              <FormItem
                label="Gêneros Literários do Clube"
                name="genres">
                <Select
                  style={{width: '100%'}}
                  mode="multiple">
                  { 
                    genres?.map(genre => {
                      return <Option value={genre.id}>{genre.content}</Option>
                    })
                  }
                </Select>
              </FormItem>
              <FileFormItem
                name="file"
                label="Foto do clube"
                >
                <ImageInput 
                  accept='image/*'
                  onChangeFile={(file)=>{
                    form.setFields([
                      {name: 'file', value: file},
                    ]);
                
                    form.validateFields(['file']);
                  }}
                />
              </FileFormItem>
              <FileFormItem
                name="docRules"
                label="Regras do clube"
                >
                <FileInput 
                  accept=".doc,.docx,.pdf,.txt"
                  onChangeFile={(file)=>{
                    form.setFields([
                      {name: 'docRules', value: file},
                    ]);
                
                    form.validateFields(['docRules']);
                  }}
                />
              </FileFormItem>
              <Spin spinning={loading}>
                <Button submit style={styles.button}>Criar clube</Button>
              </Spin>
            </Form>
          </div>
        </Spin>
      </div>
    </div>
  )
}

export default AddClub;